import { render, staticRenderFns } from "./_changeNameModal.vue?vue&type=template&id=2e6b2bc8"
import script from "./_changeNameModal.vue?vue&type=script&lang=js"
export * from "./_changeNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports